import { SubAPI } from "./SubAPI";
export class Users extends SubAPI {
    ping() { return this.fetcher.get("/api/ping"); }
    sendResetLink(input) { return this.fetcher.post("/api/users/forgot-password", input); }
    checkPasswordReset(input) { return this.fetcher.post("/api/users/check-password-reset", input); }
    resetPassword(input) { return this.fetcher.post("/api/users/reset-password", input); }
    login(input) { return this.fetcher.postForAuth("/api/auth/login", input); }
    list(input) { return this.fetcher.get("/api/users/list", input); }
    getPermissionOverrides(input) { return this.fetcher.get("/api/users/permission-overrides", input); }
    updatePermissions(input) { return this.fetcher.post("/api/users/permissions", input); }
    upsert(input) { return this.fetcher.post("/api/users", input); }
    effectivePermissions(input) { return this.fetcher.get("/api/users/effective-permissions", input); }
}
